import { LitElement, html, css, unsafeCSS } from "lit-element";

import barStyles from "./horizontal-bar-meter.scss";
import { BroadcastTemplateItemModel } from "../../../models/broadcast/broadcastTemplateModel";
import { MetricModel } from "../../../models/broadcast/metricModel";

class BarAnimationModel {
    public Width: number;
    public CurrentWidth: number;
    public Step: number;
    public Animate: Function;
    public Control: HTMLElement;

    constructor(width, control, animate) {
        this.Width = width;
        this.CurrentWidth = 0;
        this.Animate = animate;
        this.Control = control;
        this.Step = 1;
    }
}

export default class HorizontalBarMeter extends LitElement {
    private _homeMetric: MetricModel;
    private _awayMetric: MetricModel;
    private _templateItem: BroadcastTemplateItemModel;
    private _homeTeamColour: string;
    private _awayTeamColour: string;

    constructor(
        homeMetric: MetricModel,
        awayMetric: MetricModel,
        template: BroadcastTemplateItemModel,
        homeTeamColour: string,
        awayTeamColour: string) {
        super();

        this._homeMetric = homeMetric;
        this._awayMetric = awayMetric;
        this._templateItem = template;

        this._homeTeamColour = homeTeamColour;
        this._awayTeamColour = awayTeamColour;
    }

    static get styles() {
        return [
            css`${unsafeCSS(barStyles)}`
        ]
    }

    firstUpdated() {
        this.style.setProperty("--home-color", this._homeTeamColour);
        this.style.setProperty("--away-color", this._awayTeamColour);
        
        let homeTeamControl = this.shadowRoot.querySelector(`.home-team`);
        let awayTeamControl = this.shadowRoot.querySelector(`.away-team`);

        let homeValue = this._homeMetric?.value ?? 0;
        let awayValue = this._awayMetric?.value ?? 0;

        let homePercentage = homeValue / (homeValue + awayValue);
        let homeTeamAnimation = new BarAnimationModel(Math.round(homePercentage * 100), homeTeamControl, this.animateBar);
        homeTeamAnimation.Animate(homeTeamAnimation);

        let awayPercentage = awayValue / (homeValue + awayValue);
        let awayTeamAnimation = new BarAnimationModel(Math.round(awayPercentage * 100), awayTeamControl, this.animateBar);
        awayTeamAnimation.Animate(awayTeamAnimation);
    }

    animateBar(model: BarAnimationModel) {

        if (!model.Control)
            return;

        model.Control.style.width = `${model.CurrentWidth}%`;
        model.Control.style.width = `${model.Width}%`;
    }

    getBarFills() {
        return html`<div class="home-team">&nbsp;</div>
            <div class="away-team">&nbsp;</div>`;
    }

    render() {
        if (this._templateItem.hideIfValueEmpty && !this._homeMetric?.value && !this._awayMetric?.value)
            return html``;

        return [
            html`
            <div class="bar-container">
                <div class="headings">
                    <div class="percentage left${this._homeMetric?.value > this._awayMetric?.value ? 'highlight' : ''}"
                        title="${this._templateItem.name}">${this._homeMetric?.value ?? 0}${this._templateItem.suffix}</div>
                    <div><h5>${this._templateItem.name}</h5></div>
                    <div class="percentage right ${this._awayMetric?.value > this._homeMetric?.value ? 'highlight' : ''}"
                        title="${this._templateItem.name}">${this._awayMetric?.value ?? 0}${this._templateItem.suffix}</div>                    
                </div>
                <div class="progress">
                    <div class="bar">
                        ${this.getBarFills()}                        
                    </div>
                </div>
            </div>`
        ]
    }
}

window.customElements.define('broadcast-live-stats-horizontal-bar-meter', HorizontalBarMeter as any);